<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-inverse fixed-top" v-if="$store.state.isLoggedIn">
      
      <img src="@/assets/Icon58.png" style="position: absolute; left: 0; height: 50px; border-left: 4px solid #208bc9">
      <div class="navbar-brand" style="margin-left: 48px;">
        ReportBuilder
      </div>

      <div class="navbar-collapse collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <button class="btn btn-default" style="color: white;" @click="logout">
              Logout {{ `${$store.state.currentUser.firstname} ${$store.state.currentUser.lastname}` }}
            </button>
          </li>
        </ul>
      </div>
    </nav>
    <div class="container-fluid">
      <div class="row">
        <div :class="$store.state.isLoggedIn ? 'col-xs-12 col-sm-3 col-md-2' : ''" 
             v-if="$store.state.isLoggedIn && !isReportEditor">
          <AppSidebar />
        </div>
        <div :class="isReportEditor || !$store.state.isLoggedIn ? 'col' : 'col-xs-12 col-sm-9 col-md-10 mb-5'">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AppSidebar from './components/AppSidebar'

  export default {
    components: {
      AppSidebar
    },
    data() {
      return {
        isReportEditor: false
      }
    },
    watch: {
      '$route': function(to, from) {
        this.isReportEditor = to.path.startsWith('/reports/edit')
      }
    },
    mounted() {
      this.isReportEditor = this.$route.path.startsWith('/reports/edit')
    },
    methods: {
      logout() {
        this.$bvModal
            .msgBoxConfirm('Log out of ReportBuilder?', { centered: true })
            .then(async (confirm) => {
                if (confirm) {
                  this.$store.commit('clearSession')
                  this.$router.push('/login')
                }        
            })
      }
    }
  }
</script>
